import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  SearchSettingsModalContainer, type SearchSettingsModalContainerProps,
} from './searchSettingsModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    SearchSettings: Omit<SearchSettingsModalContainerProps, 'isOpen' | 'onClose'>;
  }
}

modalRenderer.register('SearchSettings', (props) => <SearchSettingsModalContainer {...props} />);
